import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { Header } from '../../components/layout/Header';
import { Footer } from '../../components/layout/Footer';
import { API } from '../../utils/api';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../components/ui/accordion';

export default function FAQPage() {
  const { language, t } = useLanguage();
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/faq`)
      .then(res => res.json())
      .then(data => setFaqs(data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-pp-bg">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="pp-container">
          <div className="max-w-3xl mx-auto">
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center mb-12"
            >
              <h1 className="pp-heading-1 text-pp-text mb-4" data-testid="faq-title">
                {t('faq.title')}
              </h1>
            </motion.div>

            {/* FAQ Accordion */}
            {loading ? (
              <div className="flex items-center justify-center py-12">
                <div className="w-8 h-8 border-2 border-pp-navy border-t-transparent rounded-full animate-spin" />
              </div>
            ) : (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
              >
                <Accordion type="single" collapsible className="space-y-4">
                  {faqs.map((faq, index) => (
                    <AccordionItem 
                      key={faq.id} 
                      value={faq.id}
                      className="pp-card border border-pp-border data-[state=open]:border-pp-navy transition-colors"
                    >
                      <AccordionTrigger 
                        className="text-left font-heading font-medium text-pp-text hover:no-underline py-0"
                        data-testid={`faq-question-${faq.id}`}
                      >
                        {language === 'fr' ? faq.question_fr : faq.question_en}
                      </AccordionTrigger>
                      <AccordionContent className="text-pp-text-secondary pt-4">
                        {language === 'fr' ? faq.answer_fr : faq.answer_en}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </motion.div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
